import React, { useState } from "react";
import { Box, IconButton, Skeleton } from "@mui/material";
import { Close, ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";

const LayoutGallery = ({ galleryImages, imgLoad, classes, floorGallery }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);

  // Function to check if media is an image
  const isImage = (media) => {
    return media?.type === "image";
  };

  // Handle opening the fullscreen mode
  const openFullscreen = (index) => {
    setCurrentIndex(index);
    setIsFullscreen(true);
  };

  // Close the fullscreen mode
  const closeFullscreen = () => {
    setIsFullscreen(false);
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % galleryImages?.length);
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? galleryImages.length - 1 : prevIndex - 1
    );
  };

  // Skeleton loader for images/videos
  if (!imgLoad && !(galleryImages?.length > 0)) {
    return (
      <>
        {floorGallery ? (
          <div className={classes.skell1}>
            <div className={classes.skell1}>
              <Skeleton
                variant="rect"
                className={classes?.skell1}
                style={{
                  width: "100%",
                  height: "300px",
                  objectFit: "cover",
                  display: "block",
                  borderRadius: 5,
                }}
              />
            </div>
          </div> // Closing div tag added here
        ) : (
          <div className={classes.gContainer}>
            <div className={classes.firstImageContainer}>
              <Skeleton
                variant="rect"
                className={classes?.galleryImage1}
                style={{
                  width: "100%",
                  height: "345px",
                  objectFit: "cover",
                  display: "block",
                  borderRadius: 5,
                }}
              />
            </div>
            <div className={classes.secondImageContainer}>
              <Skeleton
                variant="rect"
                className={classes?.galleryImage2}
                style={{
                  width: "100%",
                  height: "168px",
                  objectFit: "cover",
                  display: "block",
                  borderRadius: 5,
                }}
              />
              <Skeleton
                variant="rect"
                className={classes?.galleryImage2}
                style={{
                  width: "100%",
                  height: "168px",
                  objectFit: "cover",
                  display: "block",
                  borderRadius: 5,
                }}
              />
            </div>
          </div>
        )}
      </>
    );
  }

  return (
    <div className={classes.fullWidth}>
      {/* Grid view for images/videos */}
      {floorGallery ? (
        isImage(galleryImages[0]) ? (
          <img
            src={galleryImages[0]?.src}
            alt="Gallery "
            className={classes.floorImg}
            style={{ cursor: "pointer" }}
            onClick={() => openFullscreen(0)}
          />
        ) : (
          <video
            src={galleryImages[0]?.src}
            className={classes.floorImg}
            style={{ cursor: "pointer" }}
            onClick={() => openFullscreen(0)}
            controls
          />
        )
      ) : galleryImages?.length >= 3 ? (
        <div className={classes.gContainer}>
          <div className={classes.firstImageContainer}>
            {isImage(galleryImages[0]) ? (
              <img
                src={galleryImages[0]?.src}
                alt="First"
                className={classes.galleryImage1}
                style={{ cursor: "pointer" }}
                onClick={() => openFullscreen(0)}
              />
            ) : (
              <video
                src={galleryImages[0]?.src}
                className={classes.galleryImage1}
                controls
              />
            )}
          </div>
          <div className={classes.secondImageContainer}>
            <div className={classes.fullWidth}>
              {isImage(galleryImages[1]) ? (
                <img
                  src={galleryImages[1]?.src}
                  alt="Second "
                  className={classes.galleryImage2}
                  style={{ cursor: "pointer" }}
                  onClick={() => openFullscreen(1)}
                />
              ) : (
                <video
                  src={galleryImages[1]?.src}
                  className={classes.galleryImage2}
                  controls
                />
              )}
            </div>
            <div className={classes.fullWidth}>
              {isImage(galleryImages[2]) ? (
                <img
                  src={galleryImages[2]?.src}
                  alt="Third "
                  className={classes.galleryImage2}
                  style={{ cursor: "pointer" }}
                  onClick={() => openFullscreen(2)}
                />
              ) : (
                <video
                  src={galleryImages[2]?.src}
                  className={classes.galleryImage2}
                  controls
                />
              )}
            </div>
          </div>
        </div>
      ) : galleryImages?.length === 1 ? (
        <div className={classes.fullWidth}>
          {isImage(galleryImages[0]) ? (
            <img
              src={galleryImages[0]?.src}
              alt="First "
              className={classes.fullImg}
              style={{ cursor: "pointer" }}
              onClick={() => openFullscreen(0)}
            />
          ) : (
            <video
              src={galleryImages[0]?.src}
              className={classes.fullImg}
              controls
            />
          )}
        </div>
      ) : galleryImages?.length === 2 ? (
        <div className={classes.flexImg}>
          {isImage(galleryImages[0]) ? (
            <img
              src={galleryImages[0]?.src}
              alt="First "
              className={classes.imgCls}
              style={{ cursor: "pointer" }}
              onClick={() => openFullscreen(0)}
            />
          ) : (
            <video
              src={galleryImages[0]?.src}
              className={classes.imgCls}
              controls
            />
          )}
          {isImage(galleryImages[1]) ? (
            <img
              src={galleryImages[1]?.src}
              alt="Second "
              className={classes.imgCls}
              style={{ cursor: "pointer" }}
              onClick={() => openFullscreen(1)}
            />
          ) : (
            <video
              src={galleryImages[1]?.src}
              className={classes.imgCls}
              controls
            />
          )}
        </div>
      ) : (
        <img
          src="https://i.ibb.co/0KV0fLm/11424561.jpg"
          className={classes.placeholderImage}
          alt="Placeholder"
        />
      )}

      {/* Fullscreen View */}
      {isFullscreen && (
        <Box
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.9)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* Media Content */}
          {galleryImages[currentIndex]?.type === "video" ? (
            <video
              src={galleryImages[currentIndex]?.src}
              controls
              style={{
                maxWidth: "90%",
                maxHeight: "90%",
                borderRadius: "8px",
              }}
            />
          ) : (
            <img
              src={galleryImages[currentIndex]?.src}
              alt={`Media ${currentIndex}`}
              style={{
                maxWidth: "90%",
                maxHeight: "90%",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />
          )}

          {/* Close Button */}
          <IconButton
            onClick={closeFullscreen}
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              color: "white",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              borderRadius: "50%",
              padding: "10px",
            }}
          >
            <Close />
          </IconButton>

          {/* Previous Button */}
          <IconButton
            onClick={handlePrevious}
            style={{
              position: "absolute",
              left: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "white",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              borderRadius: "50%",
              padding: "10px",
            }}
          >
            <ArrowBackIos />
          </IconButton>

          {/* Next Button */}
          <IconButton
            onClick={handleNext}
            style={{
              position: "absolute",
              right: "20px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "white",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              borderRadius: "50%",
              padding: "10px",
            }}
          >
            <ArrowForwardIos />
          </IconButton>
        </Box>
      )}
    </div>
  );
};

export default LayoutGallery;
